module.exports = __webpack_public_path__ + "img/Delete.c22c104e.svg";